export enum OrderStatusEnum {
  RECEIVED = 1101,
	PROCESSING = 1102,
	READY = 1103,
	COMPLETED = 1104,
	CANCELLED = 1105,
	FAILED = 1106,
	REFUNDED = 1107,
	INACTIVE = 1108,
	SCHEDULED = 1109,
	DRIVER_ARRIVED_STORE = 1112,
	ORDER_PICKUP = 1113,
	DRIVER_ARRIVED_LOCATION = 1114,
	DELIVERY_CREATED = 1115,
	DASHER_CONFIRMED = 1116
}

// Function to get enum key by value
export const getOrderStatusName = (value: number, enumObject: any): string | undefined => {
  return Object.keys(enumObject).find(key => enumObject[key] == value);
}